/**
 * @file Currency related constants.
 */

/**
 * Supported currencies enum.
 *
 * @enum CURRENCY
 * @type {{USD: string}}
 */
const CURRENCY = {
  USD: 'USD',
  CAD: 'CAD',
  AUD: 'AUD',
};

/**
 * @enum CURRENCY_SYMBOLS
 */
const CURRENCY_SYMBOLS = {
  [CURRENCY.USD]: '$',
  [CURRENCY.CAD]: 'C$',
  [CURRENCY.AUD]: 'A$',
};

/**
 * Returns the currency symbol.
 *
 * @param {CURRENCY} currency - The currency.
 * @returns {string}
 */
const getCurrencySymbol = currency => {
  return CURRENCY_SYMBOLS[currency];
};

export { CURRENCY, CURRENCY_SYMBOLS, getCurrencySymbol };
